import { Head, router, usePage } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { rootPath } from "@travily/routes";
import type MessagesIndex from "@travily/types/pages/MessagesIndex";
import { Frame } from "@ui/components/Frame";
import { TopBarBorder } from "@ui/components/TopBar/TopBarBorder";
import { TopBarMobile } from "@ui/components/TopBar/TopBarMobile";
import { useNavigateBack } from "@/hooks/use-navigate-back";
import { PageFrame } from "@/layouts/page-frame";
import { ConversationListPanel } from "./conversation-list-panel";
import { MessagesIndexView } from "./index.view";

export default function MessagesIndexPage({ participations }: MessagesIndex) {
  const { url } = usePage();
  const onBack = useNavigateBack(rootPath());

  return (
    <PageFrame
      contentFills
      contentMaxWidth="full"
      contentPadded={false}
      footerFullBleed
      hideBottomBar
      hideFooter
      hideTopBarNav
      onUnreadChanged={() => router.reload({ only: ["participations", "unread_messages_count"] })}
      topBarBottomContent={<TopBarBorder />}
      mobileTopBar={<TopBarMobile bordered onBack={onBack} title={t("web.messages.index.title")} />}
    >
      <Head title={t("web.messages.index.meta_title")} />
      {/* Mounting a pane is what puts Frame into splitView, which locks the desktop page to the
          viewport instead of letting it scroll. Show does the same, so both routes share one
          scroll model. */}
      <Frame.LeftPane collapse="drill" maxWidth="medium">
        <ConversationListPanel participations={participations} url={url} />
      </Frame.LeftPane>
      <MessagesIndexView participations={participations} url={url} />
    </PageFrame>
  );
}
